import { createContext, useContext } from 'react';

const SlideContentContext = createContext({ isHidden: false });

export const useSlideContentContext = () => useContext(SlideContentContext);

export const SlideContentContextProvider = ({ isHidden, children }) => (
  <SlideContentContext.Provider value={{ isHidden }}>
    {children}
  </SlideContentContext.Provider>
);
